export default __webpack_public_path__ + "static/media/person.02b829e1.webp";